import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {SessionService} from './session.service';
import {Observable} from 'rxjs';
import {Match} from '../model/events/Match';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class StatisticsService
{
  constructor(private http: HttpClient, private sessionService: SessionService)
  {

  }

  getEventDuration(eventId: number): Observable<Match>
  {
    const url = this.sessionService.baseUrlApi + 'statistics/event/' + eventId + '/duration';
    console.log('HTTP GET: ' + url);
    return this.http.get<Match>(url);
  }

  savePlayerAverages(eventId: number, body: any): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + 'statistics/event/' + eventId + '/averages';
    console.log('HTTP POST: ' + url, body);
    return this.http.post<any>(url, body);
  }
}
